jQuery(function ($) {

    var $billingDepartment = $('#billing_department');
    var $billingDistrict   = $('#billing_district');

    if ($billingDepartment.length && $billingDistrict.length) {

        var selectedDepartmentId = $billingDepartment.data('selected-department');
        var departmentOptions    = $billingDepartment.data('options-html');

        function filterDepartments() {
            var selectedDistrict = $billingDistrict.val();
            var hasMatch = false;

            if (departmentOptions) {
                $billingDepartment.html(
                    '<option value="">Välj en avdelning</option>' +
                    departmentOptions
                );
            }

            $billingDepartment.find('option').each(function () {
                var departmentDistrict = $(this).data('district');
                var value = $(this).val();

                if (value === '' || departmentDistrict == selectedDistrict) {
                    $(this).show();
                    hasMatch = true;
                } else {
                    $(this).hide();
                }
            });

            if (hasMatch) {
                $billingDepartment.find('option[value=""]').hide();
            } else {
                $billingDepartment.find('option[value=""]').show();
            }

            $billingDepartment.val('');
        }

        $billingDistrict.on('change', filterDepartments);

        // Init
        filterDepartments();

        if (selectedDepartmentId) {
            $billingDepartment.val(selectedDepartmentId);
        }
    }

    function syncEmailToUsername() {
        var $emailField    = $('#billing_email');
        var $usernameField = $('#account_username');

        if ($emailField.length && $usernameField.length) {
            var emailVal = $emailField.val();

            if (emailVal) {
                $usernameField.val(emailVal);
            }
        }
    }

    syncEmailToUsername();

    $(document).on('input change', '#billing_email', function () {
        syncEmailToUsername();
    });

    $(document.body).on('updated_checkout', function () {
        syncEmailToUsername();
    });

});
